enum ObjectStates {
    Active = 'active',
    Deleted = 'deleted',
}

export { ObjectStates };
